import checkStateData from "../../../functions/checkStateData"
import getDateYear from "../../../functions/getDateYear"
import NewsletterTranslation from "../present/NewsletterTranslation"

const getCinameNewsleterType = (campaign, cinemasData, defaultValue = false) => {
    if(!campaign || !campaign.cinema) {
        return defaultValue
    }

    const cinemaScope = checkStateData(cinemasData, [campaign.cinema, 'scope'], false)

    return cinemaScope?.newsletterSettings?.customerDataSource ?? defaultValue
}

// const getCinameUrl = (campaign, cinemasData, getProgramUrl, defaultValue) => {
//     if(!campaign || !campaign.cinema) {
//         return defaultValue
//     }

//     const cinemaUrl = checkStateData(cinemasData, [campaign.cinema, 'website'], false)

//     if(!cinemaUrl) {
//         return defaultValue
//     } else if(getProgramUrl) {
//         return cinemaUrl + 'programmuebersicht'
//     } else {
//         return cinemaUrl
//     }
// }

const getUrl = (key, routesData, translation, defaultValue) => {
    try {
        const uri = routesData[key][translation.currentLang].uri

        if(!uri) {
            throw new Error('No uri')
        }

        return uri
    } catch(e) {
        return defaultValue
    }
}

const getCinameName = (campaign, cinemasData, defaultValue) => {
    if(!campaign || !campaign.cinema) {
        return defaultValue
    }

    const cinemaName = checkStateData(cinemasData, [campaign.cinema, 'nameDisplay'], false)

    if(cinemaName) {
        return cinemaName
    } else {
        return defaultValue
    }

}

const getCinemaAddress = (addressData, defaultValue) => {
    return addressData ? addressData : defaultValue
}

const getLogoAlt = (logoData, defaultValue) => {
    let altText = checkStateData(logoData, ['logo', 'alt'], false)

    if(altText) {
        return altText
    } else {
        return checkStateData(logoData, ['logo', 'name'], defaultValue)
    }
}

const getCinemaData = (logoData, campaign, cinemasData, addressData, translation, week, weeks, routesData) => {    
    return {
        logoUrl: checkStateData(logoData, 'url', false),
        logoAlt: getLogoAlt(logoData, <NewsletterTranslation id="print_newsletter_preview_no_alt_text" translation={translation}>Kein Alt Text vorhanden</NewsletterTranslation>),
        campaignName: checkStateData(campaign, 'name', ''),
        cinemaName: getCinameName(campaign, cinemasData, false),
        // cinemaUrl: getCinameUrl(campaign, cinemasData, false, false),
        // cinemaProgramUrl: getCinameUrl(campaign, cinemasData, true, false),
        cinemaUrl: getUrl('frontpage', routesData, translation, false),
        cinemaProgramUrl: getUrl('program_overview', routesData, translation, false),
        cinemaAddress: getCinemaAddress(addressData, {}),
        cinemaNewsletterType: getCinameNewsleterType(campaign, cinemasData, false),
        week: weeks.find(w => w.isoWeek === week),
    }
}

export default getCinemaData

